import React, {
  useEffect,
  useState,
} from 'react';
import { Link } from 'react-router-dom';

import { faUserCircle } from '@fortawesome/free-regular-svg-icons/faUserCircle';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';

import UserAvatar from './UserAvatar.jsx';

import { env } from '../../config';

const AvatarPicker = () => {
  const [res, req] = useHttpStatus();
  const [patchRes, patchReq] = useHttpStatus();
  const [picked, pick] = useState();
  const [stored, store] = useState();

  useEffect(() => {
    (async () => {
      const { payload: u } = await req({ url: '/api/core/users/self' });

      pick(u.avatar);
      store(u.avatar);
    })();
  }, []);

  return (
    <PageHttp res={res}>
      {(user) => {
        const levels = env.levels
          .filter((l) => user.score >= l.score);

        return (
          <div className="container py-4 text-center">
            <div className="text-left">
              <Link to="/app/profile" className="text-primary" >
                <img src="/assets/img/long-arrow-left.svg"/> 返回我的帳戶
              </Link>
            </div>
            <h4 className="my-4">選擇您的帳戶頭像</h4>
            <h3 className="my-4">
              您目前的帳戶等級可選擇以下頭像，
              隨著帳戶升級有機會解鎖更多頭像選擇哦！
            </h3>

            <div className="row justify-content-around">
              {[].concat(...levels.map((l) => l.avatars.map((a) => (
                <a
                  key={a}
                  className="col-auto my-4"
                  style={{ width: '200px' }}
                  onClick={() => pick(a)}
                >
                  <UserAvatar src={a} active={picked === a} />
                </a>
              ))))}
            </div>

            <div>
              <FormHttpBtn
                className="btn-primary"
                icon={faUserCircle}
                res={patchRes}
                disabled={stored === picked}
                onClick={() => {
                  let avatar;
                  const level = levels.find((l) => {
                    const a = l.avatars.indexOf(picked);

                    if (a !== -1) avatar = a;

                    return a !== -1;
                  });

                  store(picked);
                  patchReq({
                    method: 'patch',
                    url: `/api/core/users/avatar/${level._id}/${avatar}`,
                  });
                }}
              >
                更改頭像
              </FormHttpBtn>
            </div>
          </div>
        );
      }}
    </PageHttp>
  );
};

export default AvatarPicker;
